
import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer.js';

export const withDefaultContext = Component =>
  props => (
    <DefaultContainerContext.Consumer>
      {context => <Component defaultContext={context} {...props} />}
    </DefaultContainerContext.Consumer>
  )
;